import toastr from 'toastr'
import layout from 'layouts/default'
import { confirm } from 'components/modals'
import { hasPermits } from 'directives'
import newExternalEmail from "./newExternalEmail"


const directives = {
  hasPermits
}

const components = {
  layout,
  confirm,
  newExternalEmail,
}

const computed = {
  externalEmails () {
    return _.cloneDeep(this.$store.state.externalEmail.all);
  },
}

const methods = {
  removeEmail (external_email) {
    this.$refs.confirmDelete.confirm('Are you sure that you want to remove this email?', () => {
      this.$set(this.loadings, external_email.id, true)
      this.$store.dispatch('externalEmail.remove', {id: external_email.id})
      .then(() => {
        this.$set(this.loadings, external_email.id, false)
        
        let errors = _.cloneDeep(this.$store.state.externalEmail.errors);
        if (errors) {
          toastr.error(errors.message);
        } else {
          toastr.success('Email has been deleted successfully');
        }
      });
    });
  },

  updateExternalEmail(external_email, type, e) {
    let value = e.target.checked;
    external_email[type] = Number(value);
    
    this.$store.dispatch('externalEmail.edit', {
      id: external_email.id, 
      data: external_email,
    }).then(() => {
      let errors = _.cloneDeep(this.$store.state.externalEmail.errors);
      if (errors) {
        this.errors = errors.errors;
        toastr.error(errors.message);
      } else {
        toastr.success('External email updated successfully');
      }      
    })
  }
}


export default {
  name: 'external-emails',
  components,
  computed,
  methods,
  directives,
  data () {
    return {
      loading: false,
      loadings: {},
    }
  },
  created () {
    this.loading = true;

    Promise.all([
      this.$store.dispatch('externalEmail.getAll')
    ]).then(() => {
      this.loading = false;
    });
  }
}
export {default as externalEmails} from './externalEmails'
